import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const ORDER = ['light', 'dark', 'system'] as const;
type Mode = (typeof ORDER)[number];
const META: Record<Mode, { icon: typeof Sun; label: string }> = {
  light: { icon: Sun, label: 'Light' },
  dark: { icon: Moon, label: 'Dark' },
  system: { icon: Monitor, label: 'System' },
};

/** One click cycles light → dark → system; the icon shows the current choice. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const current: Mode = ORDER.includes(theme as Mode) ? (theme as Mode) : 'system';
  const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length]!;
  const { icon: Icon, label } = META[current];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label={`Theme: ${label}. Switch to ${META[next].label}`} onClick={() => setTheme(next)}>
          <Icon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Theme: {label}</TooltipContent>
    </Tooltip>
  );
}
